import { axiosPrivate } from 'app/utils';
import helpers from '../helpers';

export default {
  async getPharmacyStats({ pharmacyId }) {
    const response = await axiosPrivate.get(`/pharmacies/${pharmacyId}/stats`);
    if (response.data.error) helpers.throwError(response.data.error);

    const stats = response.data?.data?.[0];
    if (stats) return { stats };

    throw new Error('Failed to load pharmacy stats');
  },

  async getAppointmentsCountByStatus({ pharmacyId, status }) {
    const response = await axiosPrivate.get(
      `/pharmacies/${pharmacyId}/appointments/count${status ? `?status=${status}` : ''}`
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async getPatientHelpStats({ pharmacyId }) {
    const response = await axiosPrivate.get(`/v3/pharmacist/pharmacies/${pharmacyId}/issues-stats`);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },
};
